export default {
	methods: {
		validaTempoDeVoo(tipo) {
			// NAVEGAÇÃO
			if (tipo == 'NA') {
				if (this.form.hora_navegacao != '00:00') {
					this.form.navegacao = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_navegacao)
					// primeiro tempo é o ser validado
					if (this._validaTempoMenor(this.tempoVooPiloto, this.form.hora_navegacao)) {
						this.erro.navegacao = this._traducao('global', 'valorMaiorQueTempoPiloto')
					} else {
						this.erro.navegacao = ''
					}
				}
			}

			if (tipo == 'D') {
				if (this.form.hora_vfr_diurno != '00:00') {
					this.form.vfr_diurno = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_vfr_diurno)
				}
			}

			if (tipo == 'N') {
				if (this.form.hora_vfr_noturno != '00:00') {
					this.form.vfr_noturno = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_vfr_noturno)
				}
			}

			if (tipo == 'IFR') {
				if (this.form.hora_ifr != '00:00') {
					this.form.ifr = this._timeToDecimal('28/01/1991 00:00', '28/01/1991 ' + this.form.hora_ifr)
				}

				// primeiro tempo é o ser validado
				if (this._validaTempoMenor(this.tempoVooPiloto, this.form.hora_ifr)) {
					this.erro.ifr = this._traducao('global', 'valorMaiorQueTempoPiloto')
				} else {
					this.erro.ifr = ''
				}
			}
		},

		validaNull(valor) {
			if (_.isNil(valor)) {
				return ''
			}

			return valor
		},

		carregaHorimetro() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregandoHorimetro')})
			this._getHorimetro((retorno) => {
				bus.$emit('load-out')
				if (retorno) {
					this.form.horimetro_inicial = Number(Number(retorno.horimetro).toFixed(1))
				}
			}, this.aeronave.id)
		},

		carregaCamposOrdem(ordem) {
			ordem.aeronave = ordem.aeronave.map((item) => {
				item._aero = _.find(this.aeronaves, (o) => {
					return o.id == item.id_aeronave
				})

				return item
			})

			// se não tiver editando carrega os dados da ordem
			if (!this.edicao) {
				if (ordem.aeronave.length > 0) {
					var aero = _.find(ordem.aeronave, (o) => {
						return o.id_aeronave == this.aeronave.id
					})

					// não tem a aeronave selecionada na ordem
					if (_.isNil(aero)) {
						this.aerosImport = ordem.aeronave
						this.$refs.modalAero.modalShow(50)
					} else {
						this.aeronave_import = aero
						this.carregaDadosAero()
					}
				}

				//this.form.base = this.validaNull(ordem.base)

				if (!_.isNil(ordem.id_tipo_missao)) {
					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.id == ordem.id_tipo_missao
					})
				} else if (!_.isNil(ordem.tipo_missao)) {
					this.form.tipo_missao = _.find(this.tiposDeMissoes, (o) => {
						return o.descricao == ordem.tipo_missao
					})
				}

				this.form.descricao = this.validaNull(ordem.descricao)
				this.form.missao_inicio =
					ordem.data_inicio != null ? this._SQLDateToDateTime(ordem.data_inicio, $sessao.getDateFormat() + ' HH:MM') : ''
				this.form.subclassificacao =
					ordem.id_subclassificacao != null ? this.getSubclassificacaoById(ordem.id_subclassificacao) : ''

				if (this.form.subclassificacao.instrucao == '1') {
					this.form.voo_instrucao = '1'
				} else {
					this.form.voo_instrucao = '0'
				}

				this.form.houve_contexto = this.validaNull(ordem.houve_contexto)
				if (this.form.houve_contexto != null) {
					for (var i in this.contextos) {
						if (this.contextos[i].id == ordem.id_contexto_operativo) {
							this.form.contexto_operativo = this.contextos[i]
						}
					}
				}

				// orgaos recebidos
				this.form.orgao = []
				_.forEach(ordem.orgao, (org) => {
					var orgao_apoiado = {}
					var orgao = _.find(this.orgaos, (o) => {
						return o.id == org.id
					})
					orgao_apoiado.erroOrgao = ''
					orgao_apoiado.orgao = orgao
					var unidades = []

					_.forEach(org.unidade, (unidade) => {
						var uni = _.find(orgao_apoiado.orgao.unidade, (p) => {
							return p.id == unidade.id
						})
						uni.erroUnidade = ''
						unidades.push({unidade: uni, erroUnidade: ''})
					})

					orgao_apoiado.unidade = unidades
					this.form.orgao.push(orgao_apoiado)
				})
			}
		},

		getClassificacaoById(id) {
			for (var i in this.classificacoes) {
				if (this.classificacoes[i].id == id) {
					return this.classificacoes[i]
				}
			}
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		addPass(passageiro) {
			var pass = {
				data_nascimento: '',
				idade_aparente: '',
				idadeErro: '',
				sexo: '',
				sexoErro: '',
				tipo: 'P',
				nome: passageiro.nome,
				nomeErro: '',
				orgao: passageiro.orgao,
				orgaoErro: '',
				cargo: passageiro.cargo,
				cargoErro: '',
				cpf: passageiro.cpf,
				cpfErro: '',
				telefone: passageiro.telefone,
				telefoneErro: ''
			}

			this.form.passageiro.push(pass)
		},

		carregaANAC(lista, id, index) {
			if (id != '') {
				var item = _.find(lista, (o) => {
					return o.id_usuario == id
				})
				this.form.tripulacao[index].anac = item.codigo_anac
				this.form.tripulacao[index].trigrama = item.trigrama
				this.form.tripulacao[index].nome = item.nome
				this.form.tripulacao[index].base_contratual = item.base_contratual
			}
		},

		carregaANACTrigrama(lista, trigrama, index) {
			if (trigrama != '') {
				this.form.tripulacao[index].trigrama = this.form.tripulacao[index].trigrama.toUpperCase()

				var idx = _.findIndex(lista, (o) => {
					return o.trigrama == trigrama.toUpperCase()
				})

				if (idx >= 0) {
					this.form.tripulacao[index].anac = lista[idx].codigo_anac
					this.form.tripulacao[index].id_usuario = lista[idx].id_usuario
					this.form.tripulacao[index].nome = lista[idx].nome
					this.form.tripulacao[index].trigrama = lista[idx].trigrama
					this.form.tripulacao[index].base_contratual = lista[idx].base_contratual
				} else {
					this.form.tripulacao[index].anac = ''
					this.form.tripulacao[index].id_usuario = ''
					this.form.tripulacao[index].nome = ''
					this.form.tripulacao[index].trigrama = ''
					this.form.tripulacao[index].base_contratual = ''
				}
			} else {
				this.form.tripulacao[index].anac = ''
				this.form.tripulacao[index].id_usuario = ''
				this.form.tripulacao[index].trigrama = ''
				this.form.tripulacao[index].nome = ''
				this.form.tripulacao[index].base_contratual = ''
			}
		},

		getANAC(lista, trigrama, index) {
			if (trigrama != '') {
				this.form.discrepancia[index].trigrama = this.form.discrepancia[index].trigrama.toUpperCase()

				var idx = _.findIndex(lista, (o) => {
					return o.trigrama == trigrama.toUpperCase()
				})

				if (idx >= 0) {
					this.form.discrepancia[index].anac = lista[idx].codigo_anac
					this.form.discrepancia[index].id_usuario = lista[idx].id_usuario
					this.form.discrepancia[index].base_contratual = lista[idx].base_contratual
				} else {
					this.form.discrepancia[index].anac = ''
					this.form.discrepancia[index].id_usuario = ''
					this.form.discrepancia[index].trigrama = ''
					this.form.discrepancia[index].base_contratual = ''
				}
			} else {
				this.form.discrepancia[index].anac = ''
				this.form.discrepancia[index].id_usuario = ''
				this.form.discrepancia[index].base_contratual = ''
			}
		},

		carregaUsuariosTripulacao(funcao, index, zeraId) {
			var idPerfil = 0

			//console.log(funcao)

			// piloto
			if (funcao == 'Piloto em Comando' || funcao == 'Piloto em Instrução' || funcao == 'Copiloto') {
				idPerfil = 14
			}
			// trip Op
			if (funcao == 'Operador Aerotático') {
				idPerfil = 15
			}

			// mecanico
			if (funcao == 'Mecânico') {
				idPerfil = 16
			}

			//tasa
			if (funcao == 'TAS') {
				idPerfil = 17
			}

			// estagiario
			if (funcao == 'Estagiário') {
				idPerfil = '14%7C15'
			}

			this.form.tripulacao[index].load = true

			this._httpGet('Usuario/get_by_perfil/' + idPerfil, (retorno) => {
				console.log('perfil', retorno, idPerfil)
				if (retorno._request) {
					this.form.tripulacao[index].usuarios = retorno.lista.map((item) => {
						item.descricao = item.trigrama + ' - ' + item.nome
						return item
					})
					this.form.tripulacao[index].load = false
					if (zeraId) {
						this.form.tripulacao[index].id_usuario = ''
					}
					// if(carregaAnac){
					//     this.carregaANAC(this.form.tripulacao[index].usuarios, this.form.tripulacao[index].id_usuario, index)
					// }

					if (this.form.tripulacao[index].id_usuario != '') {
						this.form.tripulacao[index].pessoa = _.find(retorno.lista, (o) => {
							return o.id_usuario == this.form.tripulacao[index].id_usuario
						})
					} else {
						this.form.tripulacao[index].pessoa.codigo_anac = ''
					}

					return true
				}
			})
		},

		carregaDadosAero() {
			// tem tripulacao
			if (this.aeronave_import.tripulacao.length > 0) {
				var indexPilot = -1
				_.forEach(this.aeronave_import.tripulacao, (trip, index) => {
					if (trip.funcao.toUpperCase() == 'PILOTO EM COMANDO') {
						this.form.tripulacao[0].id_usuario = trip.id_usuario
						this.form.tripulacao[0].erroUsuario = ''
						this.form.tripulacao[0].apresentacao = this._SQLDateToDateTime(trip.apresentacao, $sessao.getDateFormat() + ' HH:MM')
						this.form.tripulacao[0].erroApresentacao = ''
						this.form.tripulacao[0].codigo_ovn = trip.codigo_ovn
						this.form.tripulacao[0].erroOVN = ''
						this.form.tripulacao[0].funcao = 'Piloto em Comando'

						this.carregaUsuariosTripulacao('Piloto em Comando', 0, false)

						indexPilot = index
					}
				})

				if (indexPilot >= 0) {
					this.aeronave_import.tripulacao.splice(indexPilot, 1)
				}

				// pega todos os outros tripulantes
				this.form.tripulacao.splice(1, this.form.tripulacao.length - 1)

				_.forEach(this.aeronave_import.tripulacao, (trip, index) => {
					this.form.tripulacao.push({
						id_usuario: trip.id_usuario,
						erroUsuario: '',
						funcao: trip.funcao,
						anac: '',
						base_contratual: '',
						apresentacao: this._SQLDateToDateTime(trip.apresentacao, $sessao.getDateFormat() + ' HH:MM'),
						erroApresentacao: '',
						codigo_ovn: trip.codigo_ovn,
						usuarios: [],
						erroFuncao: '',
						pessoa: {},
						erroOVN: ''
					})

					this.carregaUsuariosTripulacao(funcao, this.form.tripulacao.length - 1, false)
				})

				if (this.aeronave_import.carga == '1') {
					this.form.carga = this.aeronave_import.carga
					this.form.descricao_carga = this.aeronave_import.descricao_carga
					this.form.peso_carga = this.aeronave_import.peso
					this.form.carga_liquida = this.aeronave_import.carga_liquida
				}

				this.form.base = this.aeronave_import.base
			}

			if (!_.isNil(this.aeronave_import.trecho)) {
				this.escolhePassageiro(this.aeronave_import)
			} else {
				this.form.passageiro = []
			}
		},

		escolhePassageiro(aeronave) {
			if (aeronave.trecho.length > 0) {
				var passageiros = []

				_.forEach(aeronave.trecho, (ts) => {
					_.forEach(ts.passageiro, (p) => {
						p.selecionado = false

						if (passageiros.length == 0) {
							passageiros.push(p)
						} else {
							var tem = false
							for (var i in passageiros) {
								if (passageiros[i].nome == p.nome && passageiros[i].orgao == p.orgao && passageiros[i].cargo == p.cargo) {
									tem = true
									break
								}
							}

							if (!tem) {
								passageiros.push(p)
							}
						}
					})
				})

				// se exisitir passageiros a serem selecionados exibe modal
				if (passageiros.length > 0) {
					this.passageirosSelecao = passageiros
					this._exibeModal('modal-ordem-escolha-passageiros', 70)
				}
			} else {
				if (this.aeronave_import.trecho.length > 0) {
					// importa os passagueiros do trecho
					_.forEach(this.aeronave_import.trecho[0].passageiro, (p) => {
						this.addPass(p)
					})
				}
			}
		},

		// FILTA AS CIDADES DE UM ESTADO
		carregaCidades(callback, idEstado) {
			this._httpGet('/Cidade/get_cidade_by_id_estado/' + idEstado, (retorno) => {
				if (retorno._request && retorno._status) {
					retorno.lista = retorno.lista.map((t) => {
						t.descricao = t.descricao.toUpperCase()
						return t
					})
					callback({lista: retorno.lista})
				} else if (!retorno._status) {
					callback({lista: []})
				} else {
					callback({lista: []})
				}
			})
		},

		carregaSubClassificacao(item) {
			this.form.subclassificacao = ''

			if (item.id != null) {
				this.loadSub = true

				// SUBs
				this._httpGet('/Classificacao/get_subclassificacao/' + item.id, (retorno) => {
					if (retorno._request && retorno._status) {
						this.loadSub = false
						this.subclassificacoes = retorno.lista.map((item) => {
							item._descricao = item.subclassificacao + ' - ' + item.subcategoria
							return item
						})

						// verifica se tem sub e seta ela depois de carregar
						if (!_.isNil(item.id_sub)) {
							for (var i in retorno.lista) {
								if (retorno.lista[i].id == item.id_sub) {
									this.form.subclassificacao = retorno.lista[i]
									break
								}
							}
						}
					}
				})
			}
		}
	}
}
